module.exports = __webpack_public_path__ + "static/soya-c4266f89780be4ac072700b176093c91.jpg";